import { schema } from 'normalizr';

export const detectedField = new schema.Entity(
  'detectedFields',
  {},
  {
    idAttribute: 'id',
  },
);